<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fff;height:100%">
        <v-card elevation="0">
            <v-card-title>Liberação de Pagamento</v-card-title>
            <v-card-subtitle>
                Mensalmente no dia <b>10</b> todos os artistas com créditos superiores a <b>R$ 50,00</b> terão seus créditos liberados para pagamento automaticamente.
                <br />No entanto há a possibilidade de serem liberados antes manualmente nessa página.
            </v-card-subtitle>
            <v-card-actions>
                <v-btn
                    text
                    :to="{name:'liberacaopagamento_status',params:{status:'not_payed'}}"
                >créditos acumulados</v-btn>
                <v-btn
                    text
                    :to="{name:'liberacaopagamento_status',params:{status:'waiting_payment'}}"
                >aguardando pagamento</v-btn>                
                <v-btn
                    text
                    :to="{name:'liberacaopagamento_status',params:{status:'payed'}}"
                >créditos pagos</v-btn>                
            </v-card-actions>
            <v-data-table
                :footer-props="{itemsPerPageOptions:[50,100,200]}"
                :headers="headers"
                :items="items"
            >
            <template v-slot:item.artist="{ item }">    
               {{item.artist.name}}
            </template>
            <template v-slot:item.credit_value="{item}">
                <money prefix="R$ " disabled v-model="item.credit_value" v-bind="$globalformmasks.money_2p"></money>                   
            </template>
             <template v-slot:item.credit_value_full="{item}">
                <money prefix="R$ " disabled v-model="item.credit_value_full" v-bind="$globalformmasks.money_9p"></money>                   
            </template>

                <template v-slot:item.actions="{ item }">                    
                    <v-btn icon text  @click="dialog_editar_liberacao(item)">
                        &nbsp;
                        <v-icon color="green" class="mr-2" outline>stairs</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
        <!---->
        <v-dialog ref="dialog_liberar" v-model="dialog_liberar" persistent width="420px">
            <v-card>
                <v-card-title class="headline text-nowrap" >Liberação Manual de Pagamento</v-card-title>

                <v-card-text>
                    Essa ação liberará o crédito (ID: {{item_a_liberar.id}}) do artista {{item_a_liberar.artist.name}}.
                    <br />
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td>Artista</td>
                                    <td>
                                        <b>{{item_a_liberar.artist.name}}</b>
                                        
                                    </td>
                                </tr>
                                <tr>
                                    <td>Crédito a ser pago</td>
                                    <td>
                                        <b> <money prefix="R$ " disabled v-model="item_a_liberar.credit_value" v-bind="$globalformmasks.money_2p"></money></b>
                                    </td>
                                </tr>                                
                                <tr>
                                    <td colspan="2">
                                        <v-checkbox
                                            v-model="estou_ciente_check"
                                            :value="true"
                                            label="Estou ciente que ao clicar em 'liberar para pagamento' o valor será enviado para o Totus e que essa ação ficará vinculada ao histórico da minha conta."
                                        ></v-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="red darken-1" text @click="dialog_liberar = false; estou_ciente_check= false;">Cancelar</v-btn>

                    <v-btn
                        :disabled="!estou_ciente_check"
                        color="green darken-1"
                        text
                        @click="liberar_pagamento()"
                    >Liberar este pagamento</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!---->
        <!-- MODAL -->
        <modalmessage ref="modal"/>
        <!--/MODAL -->
    </v-sheet>
</template>

<script>
import LiberacaoService from "../../../../app/rest/financeiro_liberacaopagamento";
import modalmessage from "../../../../components/shared/modalmessage";
var liberacaoService = null;

export default {
    components: {
        modalmessage
    },
    data: () => ({
        item_a_liberar: {artist:{name:''},credit_value:0},
        estou_ciente_check:false,
        search: "",
        dialog_liberar: false,
        status_padrao: "not_payed",
        items: [],
        headers: [
            { text: "Artista", align: "left", sortable: false, value: "artist" },
            { text: "Créditos a liberar", value: "credit_value" },
            { text: "Créditos real", value: "credit_value_full" },
            { text: "ID do Crédito",align: "center", value: "id" },
            { text: "Primeiro crédito", value: "created_at" },
            { text: "Último crédito", value: "updated_at" },
            { text: "Ações", value: "actions" }
        ]
    }),
    beforeMount: function() {
        liberacaoService = LiberacaoService.build();
        this.load_liberacoes();
    },
    watch: {
        $route() {
            this.load_liberacoes();
        }
    },
    methods: {
        liberar_pagamento(){

        },
        liberar_credito(){          

        },
        dialog_editar_liberacao(item) {
            this.item_a_liberar = item;
            this.dialog_liberar = true;
        },
        load_liberacoes() {
            var status_padrao = this.status_padrao;
            if (this.$route.params.status) {
                status_padrao = this.$route.params.status;
            }

            this.$store.dispatch("loading");
            
            liberacaoService
                .get_all(status_padrao)
                .then(e => {
                    if (e.status == "ok") {
                        this.items = e.items.creditos;
                    }
                })
                .catch( ()=> {

                })
                .finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
    }
};
</script>